import cover_letter from './cover-letter';
import cv from './cv';
import cv_section_date from './cv-section-date';
import cv_section_date_item from './cv-section-date-item';
import cv_section_skill from './cv-section-skill';
import cv_section_skill_item from './cv-section-skill-item';
import cv_section_link from './cv-section-link';
import cv_section_link_item from './cv-section-link-item';
import cv_section_gallery from './cv-section-gallery';
import cv_section_gallery_item from './cv-section-gallery-item';
import cv_section_profile from './cv-section-profile';
import cv_section_text from './cv-section-text';

export default {
  cover_letter,
  cv,
  cv_section_date,
  cv_section_date_item,
  cv_section_skill,
  cv_section_skill_item,
  cv_section_link,
  cv_section_link_item,
  cv_section_gallery,
  cv_section_gallery_item,
  cv_section_profile,
  cv_section_text,
};
